var _defs, _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4, _path12, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopImgChicaCompleta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 536,
    viewBox: "0 0 285 536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 536,
    transform: "translate(1170 354)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1170 -354)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.604 101.428)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1197.378,924.8a124.063,124.063,0,0,0-1.219,32.754c.784,8.079,2.929,16.976,9.738,21.393,4.963,3.221,11.265,3.277,17.182,3.227l36.363-.306c8.711-.074,18.447-.569,24.438-6.895,5.784-6.107,5.975-15.456,5.822-23.867-.241-13.23-.4-26.465-.723-39.693-.2-7.98-1.064-14.806-5.36-21.636-10.046-15.971-25.791-33.392-47.036-29.274q-1.112.214-2.2.531c-8.686,2.543-17.84,14.606-22.361,22.572a125.838,125.838,0,0,0-10.278,23.4A127.344,127.344,0,0,0,1197.378,924.8Z",
    transform: "translate(-5.354 -108.445)",
    fill: "#bbb8a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.319,924.8a124.063,124.063,0,0,0-1.218,32.754c.784,8.079,2.928,16.976,9.737,21.393,4.963,3.221,11.266,3.277,17.182,3.227l36.363-.306c8.711-.074,18.448-.569,24.438-6.895,5.785-6.107,5.975-15.456,5.821-23.867-.241-13.23-.4-26.465-.723-39.693-.194-7.98-1.064-14.806-5.36-21.636-10.046-15.971-25.791-33.392-47.035-29.274-.741.143-1.477.319-2.2.531-8.686,2.543-17.84,14.606-22.361,22.572a125.838,125.838,0,0,0-10.278,23.4A127.5,127.5,0,0,0,1338.319,924.8Z",
    transform: "translate(-31.203 -108.445)",
    fill: "#bbb8a8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1189.176 271.583)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.613,350.171c10.59-14.135,7.713-33.267,15.462-48.812,7.042-18.8,33.466-40.249,51.561-22.42,5.3,8.842-6.767,16.171-10.953,22.914-23.041,40.244,33.572,66.445,57.675,89.394,29.085,38.185-67.582,48.933-91.162,51.154-37.32,6.35-73.4-12.582-56.719-54.679C1202.539,375.1,1231.957,356.95,1232.613,350.171Z",
    transform: "translate(-1194.292 -272.259)",
    fill: "#efde31"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1217.489 433.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275.475,471.244c-4.23-1.4-8.959,1.518-13.278,2-5.725,2.047-9.675,5.19-14.2,11.486-8.925,12.407-10.483,29.576-18.352,45.289-5.051,10.085,19.532,10.9,26.543,2.875,8.531-13.261,10.029-31.159,16.206-45.958C1272.971,482.064,1278.356,475.586,1275.475,471.244Z",
    transform: "translate(-1228.963 -470.867)",
    fill: "#20201d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1230.15 467.641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.843,576.071a2.7,2.7,0,0,1-.282-.629c-.155-.424-.419-1.04-.671-1.86a33.689,33.689,0,0,1-1.316-7.156,47.694,47.694,0,0,1,4.777-23.328c1.011-2.117,2.144-4.133,3.282-6.008,1.12-1.9,2.19-3.727,3.151-5.5a58.12,58.12,0,0,0,4.268-9.8c.957-2.9,1.649-5.281,2.153-6.917l.588-1.878a2.807,2.807,0,0,1,.245-.645,2.835,2.835,0,0,1-.123.68l-.472,1.915c-.429,1.659-1.054,4.058-1.96,6.99a55.635,55.635,0,0,1-4.178,9.943c-.952,1.8-2.016,3.639-3.13,5.542-1.143,1.9-2.241,3.863-3.244,5.961a48.848,48.848,0,0,0-4.9,23.028,37.5,37.5,0,0,0,1.1,7.115A23.991,23.991,0,0,1,1246.843,576.071Z",
    transform: "translate(-1244.468 -512.349)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1229.707 422.975)",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1400.612,486.535c9.029,10.2,7.126,18.561,8.568,30.377a383.617,383.617,0,0,1,2.382,63.677c-12.31-.252-24.8.229-36.988-.719-3.269,6.243-10.784,3.289-14.026-1.54-5.742-6.93-16.963-12.064-17.256-21.959a6.73,6.73,0,0,0-.15-5.4c-7.909-9.345-22.1-15.212-34.228-12.559-13.1,3.127-22.015,16.143-35.045,19.565-9.645,2.534-21.108-.281-28.889,5.956-.563-9.845-1.912-19.763-.266-29.574,3.745-22.888-.315-54.633,20.556-63.945,13.636-6.084,37.274-4.24,47.506,6.233,18.24,18.669,18.211-29.6,45.308-16.8C1374.916,465.917,1388.242,473.6,1400.612,486.535Z",
    transform: "translate(-1243.925 -457.652)",
    fill: "#20201d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.672,451.37c1.179,18.063-2.821,38.558-1.641,56.622",
    transform: "translate(-35.104 -33.524)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.054,468.9s-9.35,23.195-18.1,38.583",
    transform: "translate(-22.109 -36.739)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1244.279 288.505)",
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.9,414.872c-6.507-.351-11.675-3.841-17.109-6.91-5.92-3.621-12.488-12.186-16.194-18.129-9.271-15.511-5.3-27.11-2.87-44.582,1.389-10.011,7.261-18.1,13.011-26.009a177.341,177.341,0,0,1,16.29-18.912c2.371-2.389,4.874-5.442,8.05-6.784,2.144-.906,4.339-.558,6.541-.08,17.265,3.743,34.7,6.5,52.1,9.53.119,10.873-.178,22.417-.27,33.317.242,15.432-1.3,31.038-.2,46.423.353,2.909-.491,4.745-2.316,7.032C1344.37,406.743,1322.576,415.986,1300.9,414.872Z",
    transform: "translate(-1261.77 -292.982)",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.428,354.574c2.946-6.744,13.051-10.9,22.3,0",
    transform: "translate(-29.166 -14.543)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.22,358.9c0-5.052,13.141-14.339,20.985-2.14",
    transform: "translate(-20.875 -15.069)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.3,380.409a7.325,7.325,0,1,1-14.651,0c0-4.045,4.718-7.913,8.017-8.94",
    transform: "translate(-24.805 -18.871)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.618,403.721s7.379,15.737,32.039,0",
    transform: "translate(-24.249 -24.786)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1276.319 268.572)",
    style: {
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.868,276.651c5.989-8.7,15.149-7.79,24.186-8.079,25.378.821,46.748,19.167,54.65,42.78a129.464,129.464,0,0,1,6.134,14.748c4.261,9.351,2.4,22.34,11.289,28.886,9.988,6.571,19.852,12.1,27.693,21.463,14.638,16.134,17.8,44.752-2.171,57.807-12.407,12.1-24.082,11.9-42.421,9.189-9.35-1.383-16.33-3.865-23.735-9.678-11.74-8.1-16.072-30.353-6.557-41.357,16.041-28.184,9.1-56.71-16.514-75.985-5.863-5.029-11.953-9.808-17.513-15.182-4-3.061-6.284-8.471-10.663-10.755-2.345-.35-6.455,2.264-8.048.041A19.327,19.327,0,0,1,1304.868,276.651Z",
    transform: "translate(-1301.006 -268.572)",
    fill: "#efde31"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1284.863 407.631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1311.671,458.071c-.052-2.843-.787-6.753.913-8.995,1.416-1.867,6.615-1.785,9.593-1.809a39.355,39.355,0,0,0,14.838-3.249,46.872,46.872,0,0,0,5.179-2.537c.837-.477,1.634-1.017,2.463-1.506a5.875,5.875,0,0,1,.986-.426c.378-.143,1.022-.724,1.334-.685a15.226,15.226,0,0,1,.26,3.217l.219,3.355c.5,7.62,2.563,14.2-2.313,20.307-2.984,3.739-4.224,8.453-7.39,12.083-3.431,3.931-9,6.474-13.949,4.838-4.026-1.329-6.789-5.052-8.6-8.883a36.726,36.726,0,0,1-3.456-13.821C1311.711,459.358,1311.683,458.723,1311.671,458.071Z",
    transform: "translate(-1311.468 -438.862)",
    fill: "#fff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.906,695.784c10.008-22.538-.263-69.413,2.1-63.243-7.532-19.66.182-13.142-2.523-31.372-4.479-28.492,29.776-42.162,53.393-39.983,6.644.536,12.386,3.219,18.861,4.517,10.405,2.086,18.942,5.223,25.135,13.956,5.02,6.035-1.011,1.173,3.664,7.353,6.032,7.974,13.768,29.878,11.172,38.682-1.555,4.1-.847,8.073,1.042,11.878,3.332,16.537,5.235,12.782,2.9,29.595,13.756,43.826,21.033,80.284,37.744,123.112,3.076,7.882,14.08,42.138,14.863,50.991,1.165,17.65-4,47.184-26.288,46.342-43.8-1.654-87.85-6.231-131.636-3.289-28.393,1.908-68.077-5.266-59.926-33.361C1210.721,787.852,1222.061,760.282,1241.906,695.784Z",
    transform: "translate(-4.572 -53.623)",
    fill: "#fff",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.5,574.712c1.617,6.671,13.271,15.654,17.534,7.615,3.676-9.093,18.44-13.781,17.627-24.728-2.737-5.164-21.839-11.872-21.839-11.872s-3.025,7.75-6.117,13.7C1221.259,564.656,1214.68,569.515,1215.5,574.712Z",
    transform: "translate(-8.993 -50.829)",
    fill: "#fff",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.751,571.78c-2.338-3.358,3.117-5.315,5.167-7.091,7.513-6.508,11.765-15.8,17.022-24.248,7.27-11.69,10.584-29.164,13.121-30.419,11.153-5.519,53.983-4.508,62.571,4.379,2.158,2.233,5.408,22.631,9.189,34.466,5,15.654,20.664,34.845,10.986,50.629-31.495,16.563-25.9-15.569-54.72-24.92-16.735-5.43-34.765-9.352-51.962-5.926C1252.246,572.609,1244.562,574.467,1241.751,571.78Z",
    transform: "translate(-13.715 -43.657)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1166.397 502.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1232.223,585.067l-15.218-28.076a2.775,2.775,0,0,0-2.44-1.452h-45.359a2.775,2.775,0,0,0-2.456,1.481l-.033.064a2.772,2.772,0,0,0,.078,2.723l39.7,66.013a2.775,2.775,0,0,0,2.062,1.326l41.871,4.8a2.775,2.775,0,0,0,2.77-1.461h0a2.774,2.774,0,0,0,.039-2.517Z",
    transform: "translate(-1166.397 -555.539)",
    fill: "#a39f8d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.369 2.925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230.762,588.649l-15.689-28.943a1.118,1.118,0,0,0-.982-.585h-46.124a1.117,1.117,0,0,0-.977,1.659l38.447,69.25a1.115,1.115,0,0,0,.923.573l44.148,2.13a1.117,1.117,0,0,0,1.058-1.607Z",
    transform: "translate(-1166.849 -559.121)",
    fill: "#bbb8a8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.526 11.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1201.02,574.585a2.444,2.444,0,0,0,3.436-.379l0,0a2.445,2.445,0,0,0-.38-3.436h0a2.445,2.445,0,0,0-3.436.378h0A2.45,2.45,0,0,0,1201.02,574.585Z",
    transform: "translate(-1200.105 -570.23)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1259.965,580.288c-4.143-3.37-7.682-7.957-13.4-8.617-3.461-.881-8.526.727-8.24,4.93,1.317,5.052,11.149,8.27,15.025,12.3,1.434,1.036,4.519,3.2,4.851,4.958.047.249-6.274-.532-6.958-.541-10.95,2.5-9.308-9.341-17.176-9.592-3.116.483-4.218,4.4-4.241,7.557-.741,16.576,10.511,29.079,26.261,32.819,28.828,9.38,57.54,19.49,86.359,28.788,11.547,3.3,23.063,6.513,34.7,9.1a23.149,23.149,0,0,0,27.179-13.716c7.206-14.424,1.954-32.552,2.619-47.9-14.576.546-29.361.269-43.872,1.314.671,4.956.527,20.693.34,22.916-.242,2.887-3.207,2.334-5.459,2.28-12.327-.183-67.8-10.51-73.144-20.218-4.562-7.373-7.982-15.644-14.152-21.9C1267.563,582.293,1263.347,582.2,1259.965,580.288Z",
    transform: "translate(-1178.024 -558.455)",
    fill: "#fff",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.287 14.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1206.147,622.816c3.181-5.024-4.72-6.091-8.071-7.244l-.122-.211c3.451,1.157,8.311-.384,5.48-4.62-2.846-2.171-6.817-2.567-10.331-3.747l0,0c3.484,1.31,11.971,2.027,8.486-3.974-3.789-2.6-8.814-3.131-13.408-4.516l-14.651-25.275c-8.8,3.445,3.442,19.835,7.831,24.677a6,6,0,0,0,2.028,5.861s-3.607.9-1.352,6.988a6.856,6.856,0,0,0,4.283,9.015c-2.043,10.328,14.244,9.258,17.583,5.857l-1.166-2.012A4.169,4.169,0,0,0,1206.147,622.816Z",
    transform: "translate(-1170.423 -573.226)",
    fill: "#fff",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.08,520.709",
    transform: "translate(-35.154 -46.241)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.09,451.37",
    transform: "translate(-35.522 -33.524)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.953,516.148",
    transform: "translate(-22.109 -45.404)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.9,476.166",
    transform: "translate(-26.134 -38.072)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.143,691.019s-15.851,7.282-106.374,0",
    transform: "translate(-16.757 -77.475)",
    fill: "#fff",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopImgChicaCompleta);
export default __webpack_public_path__ + "static/media/desktop_img_chica_completa.03b99381ca70a5f443ce89b4ca254d76.svg";
export { ForwardRef as ReactComponent };